import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectPlan } from 'State/Plans/PlansActions';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import './Banner.css';

export const Banner = ({ image, className, bannerLink, promoCode, planId, handleClickBanner = null }) => {
  const dispatch = useDispatch();

  const onClick = () => {
    if (planId) {
      planId && dispatch(selectPlan(planId));
      trackEvent(TRACKING_ENUMS.EVENT_BUTTON_LINK_SELECTED, {
        page_button_text: 'Renew Now',
        page_name: 'account upgrade option offer',
        page_type: 'account',
      });
    }
    if (handleClickBanner) handleClickBanner();
  };

  // if no promo code, plan id or click handler, banner is not clickable
  if (!promoCode && !planId && !handleClickBanner) {
    return (
      <div className="imageContainer">
        <div className="desktopImage">
          <img src={image.desktop} className={className}></img>
        </div>
        <div className="mobileImage">
          <img src={image.mobile} className={className}></img>
        </div>
      </div>
    );
  }

  if (promoCode) {
    return (
      <div className="imageContainer tmtBannerPromo">
        <div className="desktopImage" onClick={onClick}>
          <img src={image.desktop} className={className}></img>
        </div>
        <div className="mobileImage" onClick={onClick}>
          <img src={image.mobile} className={className}></img>
        </div>
      </div>
    );
  }

  return (
    <div className="imageContainer">
      <Link className="desktopImage" to={bannerLink} onClick={onClick}>
        <img src={image.desktop} className={className}></img>
      </Link>
      <Link className="mobileImage" to={bannerLink} onClick={onClick}>
        <img src={image.mobile} className={className}></img>
      </Link>
    </div>
  );
};
